import type { SimState, SimConfig } from './types.js';
import type { LevelDef } from '../level/types.js';

/** Build a fresh runner state. Plain data, deterministic. */
export function createInitialState(level: LevelDef, cfg: SimConfig): SimState {
  const hh = cfg.playerH / 2;
  return {
    t: 0,
    phase: 'run',
    player: {
      pos: { x: level.spawn.x, y: level.floorY + hh, z: level.spawn.z },
      vy: 0,
      grounded: true,
      crouching: false,
      coyoteTimer: 0,
      jumpBuffer: 0,
      strideAccum: cfg.strideLength * 0.5,
    },
    boardsRead: level.boards.map(() => false),
    nearBoard: -1,
    nearObstacle: -1,
    nearHandle: false,
    inBeam: false,
    handleHigh: 'idle',
    handleCorner: 'idle',
    beamActive: false,
    complete: false,
  };
}
